<template>
    <v-select
        v-model="selectedItem"
        class="select"
        :clearable="false"
        :options="items"
        :placeholder="placeholder"
        :components="{ OpenIndicator: null }"
        @search="_search"
    >
        <template v-slot:option="option" label="label">
            <span :class="option.type">{{ option.label }}</span>
        </template>

        <template v-slot:no-options="{ search, searching }">
            <div class="no-result">{{ noResult }}</div>
        </template>
    </v-select>
</template>

<script>
import vSelect from "vue-select";

export default {
    components: {
        vSelect
    },
    props: {
        loading: {
            type: Boolean,
            required: false,
            default: false
        },
        /**
         * items is the values in the select list.
         * item in items must be of type object {id, label}
         */
        items: {
            type: Array,
            required: true
        },
        /**
         * pre-selected item. must be of type object {id, label}
         */
        /*eslint-disable */
        value: {
            required: true,
            validator: v => {
                if (v === null) {
                    return true;
                } else if (typeof v === "object") {
                    return true;
                }

                return false;
            }
        },
        /* eslint-enable */
        /**
         * text to display if no result
         */
        noResult: {
            type: String,
            default: ""
        },
        /**
         * text to display as a search hint
         */
        searchHint: {
            type: String,
            default: ""
        },
        /**
         * allows the user to write a text to search in the drop down
         */
        allowSearchTyping: {
            type: Boolean,
            default: false
        },
        /**
         * show dropdown arrow
         */
        hideDropdownArrow: {
            type: Boolean,
            default: false
        },
        labelKey: {
            type: String,
            default: "title"
        },
        hasGroups: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: ""
        },
        search: {
            type: Function,
            default: null,
            required: false
        }
    },
    computed: {
        selectedItem: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit("input", newValue);
            }
        },
        showSearchHint() {
            return this.searchHint !== "";
        },
        groupLabel() {
            return this.hasGroups ? "group" : null;
        },
        valueLabel() {
            return this.hasGroups ? "items" : null;
        }
    },
    watch: {
        loading: function(loading) {
            if (this.loadingFunc) this.loadingFunc(loading);
        }
    },
    methods: {
        _search(search, loadingFunc) {
            if (this.search) {
                this.loadingFunc = loadingFunc;
                this.search(search);
            }
        }
    }
};
</script>

<style scoped lang="scss">
$input-Dropdown-font: $input-font !default;
$input-Dropdown-color: $input-color !default;
$input-Dropdown-highlight-background: rgba(0, 0, 0, 0.1) !default;
$input-Dropdown-disabled-font: $input-Dropdown-font !default;
$input-Dropdown-disabled-color: rgba($input-Dropdown-color, 0.5) !default;
$input-Dropdown-dropdown-background: #fff !default;
$input-Dropdown-dropdown-font: $input-Dropdown-font !default;
$input-Dropdown-dropdown-color: $input-Dropdown-color !default;
$input-Dropdown-dropdown-box-shadow: none !default;

.select {
    position: static;
}

.select .no-result {
    padding: 5px 10px;
}

.select ::v-deep .vs__search,
.select ::v-deep .vs__selected,
.select ::v-deep .vs__dropdown-toggle,
.select ::v-deep .vs__dropdown-menu,
.select ::v-deep .vs__selected-options {
    border: none;
    padding: 0;
    margin: 0;
    border-radius: 0;
    font: $input-Dropdown-font;
    color: $input-Dropdown-color;
}

.select ::v-deep .vs__actions {
    padding: 0px 4px;
}

.select ::v-deep .vs__clear {
    margin: 0px;
}

.select ::v-deep .vs__dropdown-menu {
    top: calc(100% + 2px);
    box-shadow: none;
    background: $input-Dropdown-dropdown-background;
    font: $input-Dropdown-dropdown-font;
    color: $input-Dropdown-dropdown-color;
    box-shadow: $input-Dropdown-dropdown-box-shadow;

    li {
        color: $input-Dropdown-dropdown-color;
    }
}

.select ::v-deep .vs__dropdown-menu .vs__dropdown-option {
    padding: 5px 10px;
}

.select ::v-deep .vs__dropdown-menu {
    .vs__dropdown-option.vs__dropdown-option--selected,
    .vs__dropdown-option.vs__dropdown-option--highlight {
        background: $input-Dropdown-highlight-background;
        color: #000;
    }
}

.select ::v-deep .vs__spinner {
    font-size: 2px;
    width: 18px;
    height: 18px;
    border-bottom: 0.9em solid $color-primary;
    border-left: 0.9em solid $color-primary;
}

.select ::v-deep .vs__spinner:after {
    width: 18px;
    height: 18px;
}
</style>
